export default "__VITE_ASSET__CSyXtXF6__"